"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarColorBoxItem = void 0;
var tslib_1 = require("tslib");
var toolbar_interactive_item_1 = require("./toolbar-interactive-item");
var color_box_toolbar_item_template_creator_1 = require("./toolbar-item-template-creators/color-box-toolbar-item-template-creator");
var ToolbarColorBoxItem = (function (_super) {
    tslib_1.__extends(ToolbarColorBoxItem, _super);
    function ToolbarColorBoxItem(options, onCommandExecuted, onOpened, onClosed) {
        var _this = _super.call(this, options, onCommandExecuted) || this;
        _this.onOpened = onOpened;
        _this.onClosed = onClosed;
        return _this;
    }
    ToolbarColorBoxItem.prototype.getBuildTemplateStrategy = function () {
        return new color_box_toolbar_item_template_creator_1.ColorBoxToolbarItemTemplateCreator({
            itemOptions: this.options,
            onInitialized: this.getOnInitializedHandler(),
            onValueChanged: this.getOnValueChangedHandler(),
            onOpened: this.getOnOpenedHandler(),
            onClosed: this.getOnClosedHandler(),
        });
    };
    ToolbarColorBoxItem.prototype.setValue = function (value) {
        this.widget.option('value', value);
    };
    ToolbarColorBoxItem.prototype.getOnOpenedHandler = function () {
        var _this = this;
        return this.onOpened ? function () {
            _this.onOpened({
                item: _this
            });
        } : undefined;
    };
    ToolbarColorBoxItem.prototype.getOnClosedHandler = function () {
        var _this = this;
        return this.onClosed ? function () {
            _this.onClosed({
                item: _this
            });
        } : undefined;
    };
    ToolbarColorBoxItem.prototype.getOnValueChangedHandler = function () {
        var _this = this;
        return this.onCommandExecuted ? function (e) {
            _this.onCommandExecuted({
                item: _this,
                parameter: e.value
            });
        } : undefined;
    };
    return ToolbarColorBoxItem;
}(toolbar_interactive_item_1.ToolbarInteractiveItem));
exports.ToolbarColorBoxItem = ToolbarColorBoxItem;
